/** Tier-2 keys redacted in org-scope timeline diff/metadata (OAT plan P7). */
export const TIER2_TIMELINE_REDACT_KEYS = new Set([
  "customer_phone",
  "customer_email",
  "customer_address",
  "scheduling_notes",
  "deposit_deviation_note",
  "additional_items",
  "sales_adjustments",
  "format_calc_values",
  "format_calc_modes",
  "format_calc_deviation_notes",
  "proposal_pdf_url",
  "ssn",
  "social_security",
]);

export type TimelineDisplayScope = "org" | "platform";

export function redactTier2Value(key: string, value: unknown, scope: TimelineDisplayScope): unknown {
  if (scope === "platform") return value;
  if (TIER2_TIMELINE_REDACT_KEYS.has(key)) return "[redacted]";
  return value;
}

export function redactTier2Record(
  record: Record<string, unknown> | null | undefined,
  scope: TimelineDisplayScope
): Record<string, unknown> | null {
  if (!record) return null;
  if (scope === "platform") return record;
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(record)) {
    out[key] = redactTier2Value(key, value, scope);
  }
  return out;
}
